import React from 'react';

import { cn } from '@/lib/utils';

export interface ActivityDescriptionProps {
  children: React.ReactNode;
  className?: string;
}

export const ActivityDescription: React.FC<ActivityDescriptionProps> = ({
  children,
  className,
}) => {
  return (
    <div className={cn('mt-1 text-sm text-gray-600', className)}>
      {children}
    </div>
  );
};
